module.exports = __webpack_public_path__ + "img/ios-app.8d8f08e1.png";